<template>
  <section class="f-20" id="beauty" ref="root">
    <div class="beauty-3d-content" ref="car3dContent">
      <div class="bg-warp" ref="bgWarp">
        <Title1 class="bg_slogan" ref="bgSlogan" />
        <div class="bg_unveil" ref="bgUnveil" />
        <m-img
          class="bg_galaxy"
          ref="bgGalaxy"
          src="@/v2/auto/assets/image/20/galaxy.jpg"
        />
        <m-img
          class="bg_galaxy_car"
          ref="bgGalaxyCar"
          src="@/v2/auto/assets/image/20/galaxy_car.jpg"
        />
        <div class="bg_car_mask" ref="bgCarMask">
          <div class="bg-car" />
          <m-img
            class="car_mask_base"
            res="carMaskBase"
            src="@/v2/auto/assets/image/20/3d-car.png"
          />
          <m-img
            class="car_mask_1"
            ref="carMask1"
            src="@/v2/auto/assets/image/20/3d-car-mask1.png"
          />
          <m-img
            class="car_mask_2"
            ref="carMask2"
            src="@/v2/auto/assets/image/20/3d-car-mask2.png"
          />
          <m-img
            class="car_mask_3"
            ref="carMask3"
            src="@/v2/auto/assets/image/20/3d-car-mask3.png"
          />
        </div>
        <Title2 class="bg-content-1" ref="title2" />
      </div>
    </div>
  </section>
</template>
<script>
import Title1 from '@/v2/auto/assets/image/20/1_title.vue'
import Title2 from '@/v2/auto/assets/image/20/2_title.vue'
import { resizeHandle, beautyScroll } from '@/v2/auto/bus_key'
export default {
  components: {
    Title1,
    Title2,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    this.initHeight()
    this.$event.on(resizeHandle, () => {
      this.initHeight()
    })
    const {
      root,
      car3dContent,
      bgSlogan,
      bgUnveil,
      bgGalaxy,
      bgGalaxyCar,
      bgCarMask,
      carMask1,
      carMask2,
      carMask3,
      title2,
    } = this.$refs
    const gsap = this.$gsap
    // 初始化动画状态
    const initAnimationState = () => {
      // 初始化背景和标题
      gsap.set(bgUnveil, {
        maskImage:
          'linear-gradient(to top, rgb(0, 0, 0,0) 0%, rgb(0, 0, 0, 1) 0%)',
      })
      // 初始化蒙版
      gsap.set([carMask1, carMask2, carMask3], {
        maskImage: 'linear-gradient(to right, rgb(0,0,0,0) 0%, rgb(0,0,0) 0%)',
        opacity: 1,
      })
    }

    // 初始化动画
    initAnimationState()
    // 创建滚动动画事件线
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: car3dContent,
        pin: true,
        scrub: 0.5,
        fastScrollEnd: true,
        preventOverlaps: true,
        snap: {
          snapTo: 'labelsDirectional', //
          duration: { min: 0, max: 3 },
          delay: 0,
          inertia: false,
        },
        onUpdate: (self) => {
          if (self.progress === 1) {
            gsap.set(root, { pointerEvents: 'none' })
          } else {
            gsap.set(root, { pointerEvents: 'auto' })
          }
        },
        // markers: true
      },
    })
    tl.addLabel('start')
    // 揭幕渐隐消失，把银河逐渐显现完整
    tl.to(
      bgUnveil,
      {
        ease: 'power1.in',
        maskImage:
          'linear-gradient(to top, rgb(0, 0, 0,0) 0%, rgb(0, 0, 0, 0) 100%)',
      },
      'start',
    )
    // slogan渐显
    tl.to(bgSlogan.$el, { opacity: 1 }, 'start')

    tl.addLabel('showCar')
    // slogan上移
    tl.to(bgSlogan.$el, { top: '30%' }, 'showCar')
    tl.to(bgGalaxy, { opacity: 0 }, 'showCar')

    tl.addLabel('zoomInCar')
    // 车模放大
    tl.to([bgCarMask, bgGalaxyCar], { transform: 'scale(1.1)' }, 'zoomInCar')
    tl.to(bgSlogan.$el, { opacity: 0 }, 'zoomInCar')
    // 车模蒙层, 标题渐显
    tl.to([bgCarMask, title2.$el], { opacity: 1 }, 'zoomInCar')

    const maskAnimation = {
      maskImage: 'linear-gradient(to right, rgb(0,0,0,0) 100%,rgb(0,0,0) 180%)',
      ease: 'power1.in',
      duration: 3,
    }
    // 多层叠加变化
    tl.addLabel('carMarkChange')
    tl.to(carMask1, maskAnimation, 'carMarkChange')
    tl.to(carMask2, maskAnimation, 'carMarkChange+=40%')
    tl.to(carMask3, maskAnimation, 'carMarkChange+=80%')
    tl.addLabel('end')
    this.$event.on(beautyScroll, () => {
      const position = tl.scrollTrigger.labelToScroll('showCar')
      window.scrollTo({
        top: position,
        behavior: 'instant',
      })
    })
  },
  methods: {
    initHeight() {
      if (isPad) {
        this.$gsap.set([this.$refs.bgWarp], {
          height: `${window.innerHeight}px`,
        })
      }
    },
  },
}
</script>
<style lang="less" scoped>
.f-20 {
  width: 100%;
  background-color: rgb(0, 0, 0);
  position: relative;
  z-index: 80;
  height: 400vh;

  .beauty-3d-content {
    height: 300vh;
    display: flex;
    justify-content: center;
    pointer-events: none;
    .bg-warp {
      display: flex;
      align-items: center;
      position: absolute;
      z-index: 1;
      top: 0;
      width: 100%;
      height: 100vh;
      overflow: hidden;
      .bg_unveil {
        position: absolute;
        z-index: 3;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgb(0, 0, 0);
        mask-image: linear-gradient(
          to top,
          rgb(0, 0, 0) 0%,
          rgb(0, 0, 0, 0) 100%
        );
      }

      .bg_galaxy {
        position: absolute;
        z-index: 2;
        width: 100%;
        height: 100%;
        top: 0;
        object-fit: cover;
        transform-origin: 0 0;
      }
      .bg_galaxy_car {
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        top: 0;
        object-fit: cover;
        transform-origin: left;
      }

      .bg_slogan {
        position: absolute;
        opacity: 0;
        z-index: 3;
        width: 538px;
        height: 100vh;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        .slogan_title {
          font-size: 48px;
          font-weight: 300;
          font-style: italic;
        }
      }

      .bg_car_mask {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 5;
        opacity: 0;
        transform-origin: 0 0;
        transform: scale(1);
        transform-origin: left;

        .bg-car {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(150deg, #000000b0, transparent);
        }
        .car_mask_base {
          position: absolute;
          z-index: 1;
          top: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .car_mask_1 {
          position: absolute;
          z-index: 4;
          top: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .car_mask_2 {
          position: absolute;
          z-index: 3;
          top: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .car_mask_3 {
          position: absolute;
          z-index: 2;
          top: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .bg-content-1 {
        color: white;
        position: absolute;
        opacity: 0;
        top: 40%;
        z-index: 5;
        margin-left: 15%;
      }
    }
    .bg-content-2 {
      color: white;
      position: absolute;
      opacity: 0;
      top: 5%;
      z-index: 5;
      left: 15%;
    }

    .bg-content-title {
      font-size: 46px;
      font-weight: 250;
      line-height: 72px;
    }

    .bg-content-sub_title {
      margin-top: 10px;
      font-weight: 250;
      line-height: 28px;
      font-size: 18px;
    }

    .beauty_3d_kpi {
      position: absolute;
      left: 20%;
      opacity: 0;
      top: 0;
      display: flex;
      max-width: 30vw;
      flex-direction: column;
      justify-content: center;
      height: 100vh;
      img {
        height: 50vh;
        max-height: 535px;
        aspect-ratio: 535/482;
      }
    }
  }
}
</style>
